import { round } from 'lodash';

export const roundChangeDue = (features: Record<string, boolean>, amount: number): number => {
  if (features.RoundDownChangeDueToNickel) {
    const amt = Math.round(amount * 1000) / 1000;
    return Number((Math.floor(amt * 20) / 20).toFixed(2));
  }
  if (features.RoundCashChangeUpToNearestNickel) {
    const amt = Math.round(amount * 1000) / 1000;
    return Number((Math.ceil(amt * 20) / 20).toFixed(2));
  }
  if (features.RoundToNearestNickel) {
    return Number(((round((amount * 100) / 5) / 100) * 5).toFixed(2));
  }
  return round(amount, 2);
};

export const getChangeRounded = (features: Record<string, boolean>, amount: number): number => {
  // Round to 3 decimal places first to handle floating point precision issues
  // while preserving values like 0.025 and 0.075
  const preciseAmount = Math.round(amount * 1000) / 1000;

  if (features.RoundDownChangeDueToNickel) {
    const roundedDown = Math.floor(preciseAmount * 20) / 20;
    const diff = Math.round((preciseAmount - roundedDown) * 100) / 100;
    return diff > 0 ? diff * -1 : diff; // rounding down is always negative
  }
  if (features.RoundCashChangeUpToNearestNickel) {
    const roundedUp = Math.ceil(preciseAmount * 20) / 20;
    const diff = Math.round((roundedUp - preciseAmount) * 100) / 100;
    return diff > 0 ? diff : 0; // rounding up is always positive or zero
  }
  if (features.RoundToNearestNickel) {
    const roundedToNickel = Math.round(amount * 20) / 20;
    const difference = roundedToNickel - amount;
    return Math.round(difference * 100) / 100;
  }
  return 0;
};
